import { render, staticRenderFns } from "./SendgridEvents.vue?vue&type=template&id=620e75fd&scoped=true"
import script from "./SendgridEvents.vue?vue&type=script&lang=js"
export * from "./SendgridEvents.vue?vue&type=script&lang=js"
import style0 from "./SendgridEvents.vue?vue&type=style&index=0&id=620e75fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620e75fd",
  null
  
)

export default component.exports